import useGetActorSummary from "../../../hooks/useGetActorSummary";
import { KeyValueList, NoData, RLCard } from "../../../../../components";
import AIGeneratedIcon from "../../../../../components/icons/AIGeneratedIcon";
import { ActorInsightsProps } from "../../../@types/actor";
import styles from "../ioc.module.scss";

const ActorVulnerabilities = ({ actorName }: ActorInsightsProps) => {
  const { data: actorData } = useGetActorSummary(actorName || "");
  const vulnerabilities = actorData?.vulnerabilities || [];
  return (
    <RLCard
      header={
        <RLCard.Header>
          <div className="flex flex-center flex-gap-2">
            <span>Actor Related Vulnerabilities</span>
            <AIGeneratedIcon />
          </div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          {vulnerabilities.length > 1 ? (
            <KeyValueList className={styles.ioc_key_value_entry}>
              {vulnerabilities.map(vulnerability => (
                <KeyValueList.Item
                  key={vulnerability.cve_id}
                  label={`${vulnerability.cve_id}: `}
                  value={vulnerability.description || <NoData />}
                />
              ))}
            </KeyValueList>
          ) : (
            <div>No known related vulnerabilities for this actor.</div>
          )}
        </RLCard.Content>
      }
    />
  );
};

export default ActorVulnerabilities;
